import { Box, Flex, Image } from '@chakra-ui/react';

import premiumPaymentCardWithPhoneBackdrop from '../../../../../../assets/images/paymentCards/rebranded/premiumWithPhoneBackdrop.png';
import webView from '../../../../../../common/webView';
import Text from '../../../../../../components/_core/Text';
import SendDownloadAppSmsButton from '../SendDownloadAppSmsButton';
import locales from './locales';

const DownloadAppSection = () => {
  return (
    <Flex flexDirection="column">
      {webView.isInWebView ? null : (
        <>
          <Text
            fontWeight="weight-500"
            marginBottom="space-4"
            variant="primary"
          >
            {locales.downloadAppHeading}
          </Text>
          <Text marginBottom="space-16">{locales.downloadAppDescription}</Text>
          <Box marginBottom="space-24">
            <SendDownloadAppSmsButton />
          </Box>
        </>
      )}
      <Flex alignItems="center" direction="column" justifyContent="center">
        <Box backgroundColor="grey.100" padding="space-24" paddingBottom="0">
          <Flex justifyContent="center">
            <Image boxSize="80%" src={premiumPaymentCardWithPhoneBackdrop} />
          </Flex>
        </Box>
      </Flex>
    </Flex>
  );
};

export default DownloadAppSection;
